import { Tab as MuiTab, type TabProps } from '@mui/base'
import { clsx } from 'clsx'
import { type JSX } from 'react'

export const Tab = (props: TabProps): JSX.Element => {
  const { className } = props

  return <MuiTab {...props} className={clsx('tab', className)} />
}
